<template>
    <div>
        <div class="app-container mt-5">

            <div class="page-title mb-3">
                <router-link to="/configuration">
                    <span class="breadcrumb-link">
                        <v-icon class="breadcrumb-link-icon">settings</v-icon> Configuration du compte
                    </span>
                </router-link>
                <v-icon>keyboard_arrow_right</v-icon>
                <span class="breadcrumb-item">
                    <v-icon class="breadcrumb-item-icon">dashboard_customize</v-icon> Mes projets Apidae
                </span>
            </div>

            <div class="row">
                <div class="col-3">
                    <v-alert text class="mb-5">
                        Gérez ici vos projets Apidae pour utiliser des <b>sélections</b> et <b>critères internes</b>
                        Apidae.<br>
                        Pour importer un projet Apidae, il faut que celui-ci soit de type diffusion, que vous en
                        soyez propriétaire et que celui-ci soit en collaboration avec Dahub.
                        Intégrez ensuite la clé d'API (disponible dans l'onglet "informations générales" du projet sur
                        Apidae) et validez l'ajout.
                        Pour plus d'informations sur le processus, vous pouvez consulter
                        <a target="_blank"
                            href="https://intercom.help/dahub/fr/articles/6151224-6-evolutions-hubo-semaine-du-19-avril-2022">cette
                            page</a>.
                    </v-alert>
                </div>
                <div class="col">
                    <v-card class="p-4">
                        <div class="d-flex mb-5">
                            <v-btn outlined class="custom-button-primary" @click="addModal = true">
                                <v-icon left>add</v-icon> Ajouter un projet
                            </v-btn>
                        </div>

                        <v-data-table v-if="projects.length" :headers="headers" :items="projects" :loading="loading"
                            class="border" :footer-props="{
                                itemsPerPageAllText: 'Toutes',
                                itemsPerPageText: 'Projets par page',
                                itemsPerPageOptions: [10, 20, 50, 100]
                            }">
                        </v-data-table>

                        <div v-else class="text-center">
                            <small>Aucun projet n'a été ajouté pour le moment</small>
                        </div>
                    </v-card>
                </div>
            </div>

            <v-dialog v-model="addModal" persistent max-width="600px">
                <v-card>
                    <v-card-title>
                        <span class="headline">Ajout d'un projet</span>
                    </v-card-title>

                    <v-card-text>
                        <v-select :items="availableProjects" outlined label="Projet Apidae" v-model="selectedProject"
                            no-data-text="Aucun projet disponible" item-text="nom" return-object>
                        </v-select>

                        <v-text-field background-color="white" label="Clé d'API" v-model="key" outlined>
                        </v-text-field>


                        <div class="d-flex justify-content-end gap-10">
                            <v-btn @click="addModal = false">Annuler</v-btn>
                            <v-btn class="default-button custom-button-primary" @click="addProject"
                                :disabled="selectedProject === null || key === null || key === ''">Ajouter</v-btn>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "ApidaeProject",
    data() {
        return {
            loading: false,
            projects: [],
            editModal: false,
            addModal: false,
            projectName: null,
            key: null,
            projectId: null,
            selectedProject: null,
            headers: [
                {
                    text: 'Nom',
                    value: 'name'
                },
                {
                    text: 'Identifiant',
                    value: 'project_id'
                }
            ],
            selectedTag: null,
            apidaeProjects: []
        }
    },
    methods: {
        getProjects() {
            this.$http.get('auth/account/apidae-projects').then(res => {
                this.projects = res.body.data.projects

                this.projects.forEach(project => {
                    this.$set(project, 'showPassword', false)
                })
            })
        },
        addProject() {
            let payload = {
                name: this.selectedProject.nom,
                key: this.key,
                projectId: this.selectedProject.id
            }

            this.$global.loading = true

            this.$http.post('auth/account/apidae-projects/add', payload).then(res => {
                if (res.body.success) {
                    this.getProjects()

                    this.projectName = null
                    this.key = null
                    this.projectId = null
                    this.addModal = false
                }

                this.$global.loading = false
            })
        },
        getApidaeProjects() {
            this.$http.get('auth/account/apidae-member-projects').then(res => {
                this.apidaeProjects = res.body.data.projects
            })
        }
    },
    computed: {
        ...mapState('account', ['account', 'user']),
        availableProjects() {
            let projects = []

            this.apidaeProjects.forEach(proj => {
                let exist = this.projects.find(pr => pr.project_id === proj.id)

                if (!exist) {
                    projects.push(proj)
                }
            })

            return projects
        }
    },
    created() {
        this.getProjects()
        this.getApidaeProjects()
    }
}
</script>